/**
 * Labstep
 *
 * @module components/Molecule/Filter/Active
 * @desc Active filter component for molecule_inchi
 */

import { MoleculeFilter } from 'labstep-web/components/Molecule/Filter';
import { ICONS } from 'labstep-web/constants/icons';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import type React from 'react';
import type { MoleculeFilterActiveProps } from './types';

export const MoleculeFilterActive: React.FC<
  MoleculeFilterActiveProps
> = ({ clearParams, searchParams, setParams, addPostFilter }) =>
  'molecule_inchi' in searchParams ? (
    <MoleculeFilter
      entityName={''}
      searchParams={searchParams}
      setParams={setParams}
      addPostFilter={addPostFilter}
      viewComponent={({ toggleModal }) => (
        <RemoveLabel
          icon={ICONS.molecule.primary}
          name="Chemical Structure"
          onNameClick={toggleModal}
          onRemoveClick={() => clearParams(['molecule_inchi'])}
        />
      )}
    />
  ) : null;
